export function isValidExternalUrl(
  url: string | null | undefined,
): url is string {
  if (!url) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);

    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch {
    return false;
  }
}
